import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Card from "../../../../Components/Card/Card";
import VonServiceSelection from "../../../../Components/Customer/VON/AdministerLicenses/VonServiceSelection";
import { VonEditEmployeeLicensesForm } from "../../../../Components/Customer/VON/AdministerLicenses/VonEditEmployeeLicensesForm";
import routes from "../../../../Constants/Customer/customerRoutes";
import commonActions from "../../../../Actions/commonActions";
import customerActions from "../../../../Actions/customerActions";
import employeesActions from "../../../../Actions/Von/employeesActions";
import useSortingAndFiltering from "../../../../Hooks/useSortingAndFiltering";
import { useTranslation } from "react-i18next";

const VonAdministerLicenseFormContainer = () => {
    const { t } = useTranslation();
    const [services, setServices] = useState();
    const [selectedService, setSelectedService] = useState();
    const [searchInput, setSearchInput] = useState('');
    const navigate = useNavigate();
    const { pathId } = useParams();
    const dispatch = useDispatch();

    const customer = useSelector((state) => state.CustomerReducer.customer);
    const vonAccounts = useSelector((state) => state.CustomerReducer.vonAccounts);
    const vonLicenseAdministrationForm = useSelector((state) => state.CommonReducer.forms?.vonLicenseAdministrationForm);
    const vonEmployeeTypeRestrictions = useSelector((state) => state.CustomerReducer.vonEmployeeTypeRestrictions);
    const vonProducts = useSelector((state) => state.CustomerReducer.vonProducts);
    const vonProductsLoading = useSelector((state) => state.CommonReducer.dataLoading.vonProducts);

    const defaultComparer = (a, b) => (a.name || '').localeCompare(b.name || '');

    const { filteredAndSortedList, sortKey, sortOrder, handleSortChange, getSortIcon } = useSortingAndFiltering({
        list: vonAccounts || [],
        searchText: searchInput,
        searchableKeys: ['name', 'email'],
        defaultComparer
    });

    useEffect(() => {
        return () => {
            dispatch(commonActions.cancelFormEditing("vonLicenseAdministrationForm"));
        }
    }, []);

    useEffect(() => {
        if (vonAccounts && vonProducts) {
            const servicesWithLicenses = vonProducts.filter(product => product.licenses > 0);
            setServices(servicesWithLicenses);
            setSelectedService(servicesWithLicenses[0]);
            dispatch(employeesActions.beginVonLicenseAdministrationForm(vonAccounts, servicesWithLicenses[0]));
        }
    }, [vonAccounts, vonProducts]);

    const onChangeService = (service) => {
        dispatch(employeesActions.beginVonLicenseAdministrationForm(vonAccounts, service));
        setSelectedService(service);
    }

    const onChange = (form, value, field) => {
        dispatch(commonActions.changeMultiFormField(form, field, value));
    }

    const navigateToUsers = () => {
        navigate(routes.customer(pathId, routes.Users));
    }

    const callBack = () => {
        dispatch(customerActions.getVonAccounts(customer.vonCustomer.id));
        navigateToUsers();
    }

    const onSubmit = () => {
        dispatch(employeesActions.bulkUpdateVonEmployeeServices(vonLicenseAdministrationForm, callBack));
    }

    let isLoading = vonProductsLoading || !vonLicenseAdministrationForm || !selectedService;
    let isChanged = vonLicenseAdministrationForm?.changed;

    return (
        <Card>
            <Card.Header>
                <Card.Header.Title>{t("employeeLicenses.administerLicenses")}</Card.Header.Title>
            </Card.Header>
            <Card.Content isLoading={isLoading}>
                <div className="d-grid gap-24">
                    <fieldset className="d-grid gap-24 mb-0 pl-0">
                        <VonServiceSelection
                            selectedService={selectedService?.productNumber}
                            onChange={onChangeService}
                            services={services}
                        />
                        <div className="mb-10">
                            <input 
                                id="employeefilter" 
                                placeholder={t("vonaccountscontainer.searchfield")} 
                                className="form-control" 
                                type="text"
                                value={searchInput} 
                                onChange={(e) => setSearchInput(e.target.value)} 
                            />
                        </div>
                        <VonEditEmployeeLicensesForm
                            onChange={onChange}
                            service={selectedService}
                            vonAccounts={filteredAndSortedList}
                            form={vonLicenseAdministrationForm}
                            vonEmployeeTypeRestrictions={vonEmployeeTypeRestrictions}
                            sortKey={sortKey}
                            sortOrder={sortOrder}
                            handleSortChange={handleSortChange}
                        />
                    </fieldset>
                </div>
            </Card.Content>
            <Card.Footer>
                <Card.Footer.Buttons>
                    <button className="btn btn-default" onClick={navigateToUsers}>
                        {t("common.back")}
                    </button>
                    <button className="btn btn-default" onClick={onSubmit} disabled={isLoading || !isChanged}>
                        {t("common.save")}
                    </button>
                </Card.Footer.Buttons>
            </Card.Footer>
        </Card>
    );
}

export default VonAdministerLicenseFormContainer;